// eslint-disable-next-line func-names
(function () {
    function $arrayExtender(arr) {
        function firstOfBlock(index, comparer) {
            const isFirstEl = index === 0;
            if (isFirstEl) { return isFirstEl }
            return comparer(arr[index - 1]) !== comparer(arr[index]);
        }
        function lastOfBlock(index, comparer) {
            const isLastEl = index === arr.length - 1;
            if (isLastEl) { return isLastEl }
            return comparer(arr[index]) !== comparer(arr[index + 1]);
        }
        function merge(...arrays) {
            for (let i = 0; i < arrays.length; i++) {
                const element = arrays[i];
                if (!Array.isArray(element)) {
                    throw new TypeError('Każdy mergowany element musi byc tablica');
                }
            }
            return [...new Set([...arr, ...arrays.flat()])];
        }
        function remove(...args) {
            let what;
            const a = args;
            let L = a.length;
            let ax;
            while (L && arr.length) {
                what = a[--L];
                // eslint-disable-next-line no-cond-assign
                while ((ax = arr.indexOf(what)) !== -1) {
                    arr.splice(ax, 1);
                }
            }
            return arr;
        }
        return {
            firstOfBlock,
            lastOfBlock,
            merge,
            remove
        };
    }

    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Array.prototype, 'extensions', {
        set() {},
        get() {
            return $arrayExtender(this);
        }
    });
}());
